export default {
  state: {
    isError: false,
    errors: [],
  },

  mutations: {
    setIsError(state, value) {
      state.isError = value;
    },
    setErrors(state, value) {
      state.errors = []
      state.errors.push(value);
      state.isError = true;
      setTimeout(() => {
        if (state.errors.length === 0) {
          state.isError = false;
        }
      }, 4000);
    },
    resetErrors(state) {
      state.isError = false;
      state.errors = [];
    },
  },
};
